var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable class-methods-use-this */
import PCLNAnalytics from '@pcln/analytics';
export class Analytics {
  init(data) {
    this.chatbotContext = data;
  }
  // fire GA4 event
  fireGA4Event(ga4EventParams) {
    try {
      PCLNAnalytics.GA4Enabled = true;
      PCLNAnalytics.logEvent(ga4EventParams);
    } finally {
      PCLNAnalytics.GA4Enabled = false;
    }
  }
  // Log an error
  // sample query 'index=cheetah sourcetype=ESBROWSEREVENTDATA_ESSVCS action=Error'
  logError(logData) {
    PCLNAnalytics.logError(Object.assign(Object.assign({}, this.getBaseAttributes()), logData));
  }
  // Log directly to Splunk
  // sample query 'index=cheetah sourcetype=ESBROWSEREVENTDATA_ESSVCS action=Log'
  log(_a) {
    var {
        message = ''
      } = _a,
      rest = __rest(_a, ["message"]);
    PCLNAnalytics.log(Object.assign(Object.assign({
      message
    }, this.getBaseAttributes()), rest));
  }
  // Log a warning
  // sample query 'index=cheetah sourcetype=ESBROWSEREVENTDATA_ESSVCS action=warning'
  logWarning({
    name = '',
    message = ''
  }) {
    PCLNAnalytics.logWarning(Object.assign({
      name,
      message
    }, this.getBaseAttributes()));
  }
  getBaseAttributes() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const isBrowser = typeof window !== 'undefined';
    const componentVersionFromWindow = isBrowser ? (_b = (_a = window === null || window === void 0 ? void 0 : window.PCLN_BOOTSTRAP_DATA) === null || _a === void 0 ? void 0 : _a.moduleInfo) === null || _b === void 0 ? void 0 : _b['@pcln/penny-chat-bot'] : 'unknown';
    return {
      component: 'PennyChatbot',
      componentVersion: ((_c = this.chatbotContext) === null || _c === void 0 ? void 0 : _c.componentVersion) || componentVersionFromWindow,
      requestFrom: (_f = (_e = (_d = this.chatbotContext) === null || _d === void 0 ? void 0 : _d.fetchRequestOptions) === null || _e === void 0 ? void 0 : _e.headers) === null || _f === void 0 ? void 0 : _f['x-request-from'],
      productId: (_h = (_g = this.chatbotContext) === null || _g === void 0 ? void 0 : _g.submitChatMessagesPayload) === null || _h === void 0 ? void 0 : _h.productId,
      cguid: (_k = (_j = this.chatbotContext) === null || _j === void 0 ? void 0 : _j.submitChatMessagesPayload) === null || _k === void 0 ? void 0 : _k.cguid,
      rguid: (_m = (_l = this.chatbotContext) === null || _l === void 0 ? void 0 : _l.submitChatMessagesPayload) === null || _m === void 0 ? void 0 : _m.rguid
    };
  }
}
export default new Analytics();